import PropTypes from "prop-types"
import React, { useState, useEffect, useCallback, useRef } from "react"
import {
  Container,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Label,
  Input,
} from "reactstrap"
import ReactPlayer from "react-player"
import "react-multi-carousel/lib/styles.css"
import { SECURITY_KEY, BASE_URL } from "../../global"
import { Link, useParams, useLocation, useNavigate } from "react-router-dom"
import classnames from "classnames"

import awicon from "../../assets/images/services-icon/coin.png"
import duration from "../../assets/images/services-icon/duration.png"

// import circle from "../../assets/images/services-icon/circle.png"
// import rectangle from "../../assets/images/services-icon/rectangle.png"
// import square from "../../assets/images/services-icon/square.png"

import Select from "react-select"
// import images

import fr1 from "../../assets/images/services-icon/fr1.png"
import dsmile from "../../assets/images/services-icon/dog_smile.png"
import BackwardIcon from "../../assets/images/services-icon/backward.png"
import PauseIcon from "../../assets/images/services-icon/pause.png"

//i18n
import { withTranslation } from "react-i18next"
import { sample } from "lodash"
// import Duration from './Duration';
import Iframe from "react-iframe"
import axios from "axios"
// import { BASE_URL } from "../../global";

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import moment from "moment"

import Loader from "react-spinner-loader"

import { fabric } from "fabric"
import { pdfjs } from "react-pdf"
//import { PDFDocument } from 'pdf-lib';
import jsPDF from "jspdf"
import {
  parseInteractiveResult,
  interactivePdfUrl,
} from "../../modules/interactive-worksheet/worksheet-result"
const PreviewWorkSheet = props => {
  document.title = "MyGooRoo Student App"
  const { key } = useParams()

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const type = searchParams.get("type") || null
  const homework = searchParams.get("homework") || null
  const st_key = searchParams.get("st_key") || null
  const auth = searchParams.get("auth") || null
  const is_trial = searchParams.get("is_trial") || 0;

  let pk_activity_key = null
  let IsType = null
  let IsHomework = null
  let IsStKey = null
  let authUser = '';
  let IsTrial = 0;
  if (
    key &&
    key.length >= 16 &&
    type &&
    type != null &&
    homework &&
    homework != null &&
    st_key &&
    st_key != "" &&
    auth &&
    auth != ""
  ) {
    pk_activity_key = key
    IsType = type
    IsHomework = homework
    IsStKey = st_key
    authUser = auth
    IsTrial = is_trial
  } else {
    window.history.back()
  }

  const [loader, setLoader] = useState(false)
  const [ActivityData, setActivityData] = useState([])

  //Timmere start

  // const [seconds, setSeconds] = useState(0)
  // const [isRunning, setIsRunning] = useState(false)

  // useEffect(() => {
  //   let timer
  //   if (isRunning) {
  //     timer = setInterval(() => {
  //       setSeconds(prevSeconds => prevSeconds + 1)
  //     }, 1000)
  //   }

  //   return () => clearInterval(timer)
  // }, [isRunning])

  // const formatTime = time => {
  //   const minutes = Math.floor(time / 60)
  //   const remainingSeconds = time % 60
  //   return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
  //     .toString()
  //     .padStart(2, "0")}`
  // }

  // const handleToggleTimer = () => {
  //   setIsRunning(prevState => !prevState)
  // }

  // const handleResetTimer = () => {
  //   setSeconds(0)
  //   setIsRunning(true)
  // }

  //Timer end
  //worksheet

  const [imageUrls, setImageUrls] = useState([])
  const [canvasList, setCanvasList] = useState([])
  const [pdfInstance, setPdfInstance] = useState(null)

  // const [historyIndex, setHistoryIndex] = useState(-1);
  // const [canvasHistory, setCanvasHistory] = useState([]);
  const [currentColor, setCurrentColor] = useState("black")

  const colorRef = useRef()
  colorRef.current = currentColor

  const [drawMode, setDrawMode] = useState(false) // State for text mode
  const drawModeRef = useRef()
  drawModeRef.current = drawMode

  const [textMode, setTextMode] = useState(false) // State for text mode
  const textModeRef = useRef()
  textModeRef.current = textMode

  const [selectedShape, setSelectedShape] = useState("circle") // State for selected shape
  const [shapMode, setShapMode] = useState(false)
  const shapModeRef = useRef()
  shapModeRef.current = shapMode

  const shapDataRef = useRef()
  shapDataRef.current = selectedShape

  const [zoomLevel, setZoomLevel] = useState(1)

  //const authUser = JSON.parse(localStorage.getItem("authStudentUser")) || null
  const navigate = useNavigate()
  useEffect(() => {
    fetchData()
  }, [location])

  const fetchAttendanceData = async () => {
    //  // if (authUser && authUser != "" && authUser != null) {
    //     if (pk_activity_key && pk_activity_key != null && pk_activity_key != "") {
    //       axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
    //       axios
    //         .post(BASE_URL+"studentSession/StudentAttendance", {
    //           pk_activity_key: pk_activity_key,
    //         })
    //         .then(responseAttendance => {})
    //         .catch(error => {
    //           if (
    //             (error?.response?.status === 403 || error?.response?.status === 401) &&
    //             (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
    //           ) {
    //             localStorage.clear()
    //             navigate("/login")
    //           }
    //         })
    //     } else {
    //       window.history.back()
    //     }
    //   } else {
    //     navigate("/login")
    //   }
  }

  const fetchData = async () => {
    if (authUser && authUser != "" && authUser != null) {
    if (pk_activity_key && pk_activity_key != null && pk_activity_key != "") {
      setLoader(true)
      setActivityData([])
      axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
      axios
        .post(BASE_URL + "studentSession/StudentPreviewAssessmentQuestions", {
          pk_activity_key: pk_activity_key,
          subject_id: type,
          pk_student_key: IsStKey,
        })
        .then(responseActivity => {
          // Assuming the API response is an array of objects with 'id' and 'value' properties
          setLoader(false)

          if (responseActivity.data.LessonActivitiesQuestions.length > 0) {
            setActivityData(responseActivity.data)

            responseActivity.data.LessonActivitiesQuestions.forEach(
              (activityQuestion, index2) => {
                //if (activityQuestion.question && activityQuestion.question.length > 0) {
                let answerLength = activityQuestion.StudentAnsAttempts.length

                if (parseInt(IsHomework) === 1) {
                  if (answerLength <= 0) {
                  }
                } else {
                  if (answerLength <= 0) {
                    //console.log('attented');
                  }
                }

                // }
              }
            )
          } else {
            toast.error("Question data not found", {
              autoClose: 3000, // 3 seconds
              onClose: () => {
                history.back() // Navigate back in history after toast is closed
              },
            })
            setActivityData([])
          }
        })
        .catch(error => {
          setLoader(false)
          console.log(error)
          if (
            (error?.response?.status === 403 || error?.response?.status === 401) &&
            (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
          ) {
            localStorage.clear()
            window.history.back()
          }
        })
    } else {
      setLoader(false)
      window.history.back()
    }
    } else {
      setLoader(false)
      window.history.back()
    }
  }

  useEffect(() => {
    // not conver to url
    // https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/activity_pdf/english_activity_pdf/Year_5_Vocabulary_S__Year_5_Vocabulary_S_1710151837_Q.pdf

    //DIRECT URL
    //https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/tutor/library/1707203418570_PdfForm.pdf

    //student direct URL
    //https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/student/submissions/worksheet_submission_1711431708116.pdf
    if (ActivityData && ActivityData != "") {
      let pdfUrl = ""
      const submittedAnswer =
        ActivityData?.LessonActivitiesQuestions?.[0]?.StudentAnsAttempts?.[0]
          ?.student_answer
      // An interactive worksheet stores its marking result in student_answer, so
      // the PDF to show comes from inside it. Falls through to the blank worksheet
      // below when the filled copy could not be saved.
      const interactiveResult = parseInteractiveResult(submittedAnswer)
      if (interactiveResult) {
        pdfUrl = interactivePdfUrl(interactiveResult)
      } else if (submittedAnswer) {
        pdfUrl = submittedAnswer
      }

      if (
        !pdfUrl &&
        ActivityData &&
        ActivityData.fk_sub_id &&
        ActivityData.activity_type &&
        parseInt(ActivityData.activity_type) === 7 &&
        ActivityData.activity_node &&
        ActivityData.activity_node.length > 0
      ) {
        if (parseInt(ActivityData.fk_sub_id) === 1) {
          pdfUrl =
            "https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/activity_pdf/english_activity_pdf/" +
            ActivityData.activity_node[0].file_name
        } else if (parseInt(ActivityData.fk_sub_id) === 2) {
          pdfUrl =
            "https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/activity_pdf/math_activity_pdf/" +
            ActivityData.activity_node[0].file_name
        }
      } else if (
        !pdfUrl &&
        ActivityData &&
        ActivityData.fk_sub_id &&
        ActivityData.activity_type &&
        parseInt(ActivityData.activity_type) === 5 &&
        ActivityData.activity_node &&
        ActivityData.activity_node.length > 0
      ) {
        // if (parseInt(ActivityData.fk_sub_id) === 1) {
          pdfUrl = ActivityData.activity_node[0].link
            ? ActivityData.activity_node[0].link
            : ""
        // } else if (parseInt(ActivityData.fk_sub_id) === 2) {
        //   pdfUrl = ActivityData.activity_node[0].link
        //     ? ActivityData.activity_node[0].link
        //     : ""
        // }
      }

      // const pdfUrl1 = 'https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/activity_pdf/math_activity_pdf/Angles_Triangles_an_Angles_Triangles_an_1702259819_Q.pdf'; // Update with your PDF URL
      pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

      const fetchPdfAndConvert = async () => {
        try {
          const response = await fetch(pdfUrl)
          const blob = await response.blob()
          const reader = new FileReader()

          reader.onload = async e => {
            const data = atob(e.target.result.replace(/.*base64,/, ""))
            renderPages(data)
          }

          reader.readAsDataURL(blob)
        } catch (error) {
          console.error("Error fetching or converting PDF:", error)
        }
      }
      const renderPages = async data => {
        const imagesList = []
        const canvases = []
        const pdf = await pdfjs.getDocument({ data }).promise

        const canvasContainer = document.getElementById("Canvas_list")

        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i)
          const viewport = page.getViewport({ scale: 1.5 })

          // Create a div for the canvas and page number display
          const pageDiv = document.createElement("div")
          pageDiv.classList.add("canvas-page-container")

          const pageNumberDiv = document.createElement("div")
          pageNumberDiv.classList.add("d-flex", "justify-content-center")

          const pageNumberParagraph = document.createElement("p")
          pageNumberParagraph.textContent = `${i}/${pdf.numPages}`

          pageNumberDiv.appendChild(pageNumberParagraph)
          pageDiv.appendChild(pageNumberDiv)

          const canvasContainerDiv = document.createElement("div")
          canvasContainerDiv.classList.add("d-flex", "justify-content-center")

          const canvasElem = document.createElement("canvas")
          canvasElem.id = `fabric-canvas-${i}` // Unique ID for each canvas
          canvasElem.height = viewport.height
          canvasElem.width = viewport.width

          canvasContainerDiv.appendChild(canvasElem)
          pageDiv.appendChild(canvasContainerDiv)

          canvasContainer.appendChild(pageDiv)

          const fabricCanvas = new fabric.Canvas(canvasElem)
          // Add click event listener to canvas
          fabricCanvas.on("mouse:down", function (event) {
            handleCanvasClick(event, fabricCanvas)
            handleShapeCreation(event, fabricCanvas)
          })

          canvases.push(fabricCanvas)

          const renderContext = {
            canvasContext: fabricCanvas.getContext("2d"),
            viewport: viewport,
          }

          await page.render(renderContext).promise
          const img = canvasElem.toDataURL("image/png")
          imagesList.push(img)
        }

        setImageUrls(imagesList)
        setCanvasList(canvases)
        setPdfInstance(pdf)
      }
      fetchPdfAndConvert()
    }
  }, [ActivityData])
  //console.log(ActivityData)

  useEffect(() => {
    //enable draw option
    canvasList.forEach(canvas => {
      canvas.isDrawingMode = drawMode // Enable drawing mode
    })
  }, [drawMode])

  const handleCanvasClick = (event, canvas) => {
    if (textModeRef.current) {
      const { x, y } = event.pointer
      const textbox = new fabric.Textbox("Enter text", {
        left: x,
        top: y,
        width: 150,
        fill: colorRef.current, // Set text color
      })
      canvas.add(textbox)
      canvas.setActiveObject(textbox)
      canvas.renderAll()
    }
  }

  const handleShapeCreation = (event, canvas) => {
    if (shapModeRef.current) {
      // Handle shape creation
      const { x, y } = event.pointer

      switch (shapDataRef.current) {
        case "circle":
          const circle = new fabric.Circle({
            radius: 50,
            left: x,
            top: y,
            fill: "transparent", // Set fill color to transparent
            stroke: colorRef.current,
          })
          canvas.add(circle)
          break
        case "rectangle":
          const rectangle = new fabric.Rect({
            width: 100,
            height: 50,
            left: x,
            top: y,
            fill: "transparent", // Set fill color to transparent
            stroke: colorRef.current,
          })
          canvas.add(rectangle)
          break
        case "square":
          const square = new fabric.Rect({
            width: 50,
            height: 50,
            left: x,
            top: y,
            fill: "transparent", // Set fill color to transparent
            stroke: colorRef.current,
          })
          canvas.add(square)
          break
        default:
          break
      }
    }
  }

  useEffect(() => {
    imageUrls.forEach((imageUrl, index) => {
      const canvas = canvasList[index]

      fabric.Image.fromURL(imageUrl, img => {
        img.set({
          left: 0,
          top: 0,
          selectable: false, // Disable object selection/movement
          evented: false,
        })

        img.scaleToWidth(canvas.width)
        canvas.add(img)
        canvas.renderAll()
      })
    })
  }, [imageUrls, canvasList])

  //Toggles
  const toggleTextMode = () => {
    setDrawMode(false)
    setShapMode(false)
    setTextMode(!textMode) // Toggle text mode state
  }

  const toggleDrawMode = () => {
    setTextMode(false)
    setShapMode(false)
    setDrawMode(!drawMode) // Toggle text mode state
    // Update brush color when switching draw mode
    if (!drawMode) {
      canvasList.forEach(canvas => {
        canvas.freeDrawingBrush.color = currentColor
      })
    }
  }

  const toggleShapeMode = value => {
    setTextMode(false)
    setDrawMode(false) // Toggle text mode state
    setShapMode(true) // Toggle text mode state
    setSelectedShape(value)
  }

  const ClickShapeMode = () => {
    setTextMode(false)
    setDrawMode(false) // Toggle text mode state
    setShapMode(!shapMode) // Toggle text mode state
  }

  const zoomIn = () => {
    setZoomLevel(prevZoom => prevZoom + 0.1)
    adjustZoom(1.1)
  }

  const zoomOut = () => {
    setZoomLevel(prevZoom => (prevZoom > 0.1 ? prevZoom - 0.1 : prevZoom))
    adjustZoom(0.9)
  }

  const resetZoom = () => {
    setZoomLevel(1)
    adjustZoom(1 / zoomLevel) // Reset to original zoom level (1)
  }

  const adjustZoom = factor => {
    canvasList.forEach(canvas => {
      const zoom = canvas.getZoom() * factor
      canvas.setZoom(zoom)
      canvas.requestRenderAll()
    })
  }

  //  // Function to save canvas state to history
  //  const saveCanvasToHistory = (canvas) => {
  //   const newHistory = canvasHistory.slice(0, historyIndex + 1);
  //   newHistory.push(canvas.toJSON());
  //   setCanvasHistory(newHistory);
  //   setHistoryIndex(historyIndex + 1);
  // };

  // // Function to handle undo action
  // const undoAction = () => {
  //   if (historyIndex > 0) {
  //     const newIndex = historyIndex - 1;
  //     setHistoryIndex(newIndex);
  //     const canvasData = canvasHistory[newIndex];
  //     canvasList.forEach((canvas) => {
  //       canvas.loadFromJSON(canvasData, () => {
  //         canvas.renderAll();
  //       });
  //     });
  //   }
  // };

  // // Function to handle redo action
  // const redoAction = () => {
  //   if (historyIndex < canvasHistory.length - 1) {
  //     const newIndex = historyIndex + 1;
  //     setHistoryIndex(newIndex);
  //     const canvasData = canvasHistory[newIndex];
  //     canvasList.forEach((canvas) => {
  //       canvas.loadFromJSON(canvasData, () => {
  //         canvas.renderAll();
  //       });
  //     });
  //   }
  // };

  // Function to remove selected object from canvas
  const removeSelectedObject = () => {
    canvasList.forEach(canvas => {
      const activeObject = canvas.getActiveObject()
      if (activeObject) {
        canvas.remove(activeObject)
        //saveCanvasToHistory(canvas);
      }
    })
  }

  const changeColor = color => {
    setCurrentColor(color)
    if (drawMode) {
      // Set stroke color for drawing objects
      canvasList.forEach(canvas => {
        canvas.freeDrawingBrush.color = color
      })
    } else {
      // Set fill color for shape creation or text color
      canvasList.forEach(canvas => {
        const activeObject = canvas.getActiveObject()
        if (activeObject) {
          if (activeObject.type === "textbox") {
            activeObject.set("fill", color)
          } else {
            activeObject.set("stroke", color)
          }
          canvas.renderAll()
          //saveCanvasToHistory(canvas);
        }
      })
    }
  }

  const downloadPdf = () => {
      resetZoom()
  
      // Function to resize and compress image manually using canvas
      const compressImage = canvas => {
        // Resize and compress the canvas image
        const dataUrl = canvas.toDataURL("image/jpeg", 1.0)
  
        const img = new Image()
        img.src = dataUrl
  
        return new Promise(resolve => {
          img.onload = () => {
            // Create a temporary canvas for resizing
            const offCanvas = document.createElement("canvas")
            const ctx = offCanvas.getContext("2d")
            const maxWidth = 1500; // Higher resolution for better quality
            const maxHeight = 1500;
    
            const width = img.width;
            const height = img.height;
            const scale = Math.min(maxWidth / width, maxHeight / height, 1);
    
            offCanvas.width = Math.round(width * scale);
            offCanvas.height = Math.round(height * scale);
    
            // Apply high-quality scaling
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = "high";
            ctx.drawImage(img, 0, 0, offCanvas.width, offCanvas.height);
    
  
            // Get the resized image as a data URL (compressed further by adjusting quality)
            const resizedDataUrl = offCanvas.toDataURL("image/jpeg", 1.0) // Further compress the image
  
            resolve(resizedDataUrl) // Return the resized image
          }
        })
      }
  
  
      
      // Generate PDF from resized and compressed canvas images
      const generatePdf = async () => {
        const doc = new jsPDF()
        doc.internal.scaleFactor = 2.0; 
        // Compress and add each canvas image to the PDF
        for (let i = 0; i < canvasList.length; i++) {
          const canvas = canvasList[i]
          const compressedImage = await compressImage(canvas)
  
          // Add compressed image to the PDF
          const pageWidth = doc.internal.pageSize.getWidth()
          const pageHeight = doc.internal.pageSize.getHeight()
          // Set high-contrast black text color
          doc.setTextColor(0, 0, 0); // Ensures deep black text
          doc.setFont("helvetica", "bold"); // Use a bold font for better readability
  
          doc.addImage(compressedImage, "JPEG", 0, 0, pageWidth, pageHeight)
  
          // Add a new page if it's not the last image
          if (i !== canvasList.length - 1) {
            doc.addPage()
          }
        }
  
        // Save the PDF
        doc.save("worksheet_submission_" + generateRandomFileName() + ".pdf")
      }
  
      generatePdf()
    }
  // Function to generate a random 13-digit number
  const generateRandomFileName = () => {
    const min = 1000000000000 // Minimum 13-digit number
    const max = 9999999999999 // Maximum 13-digit number
    return Math.floor(Math.random() * (max - min + 1)) + min
  }
 

  // console.log(ActivityData);
  // console.log(selectQuestion);
  return (
    <React.Fragment>
      <Loader
        show={loader}
        type="body"
        // stack="vertical"
        // message="Loading Data"
      />
      <ToastContainer autoClose={3000} />
      <div className="page-wrapper">
        <div  style={{
                      zIndex: 1000,
                      position: "fixed",
                      top: 0,
                      width: "100%",
                      transition: "top 0.3s ease-in-out"
                      }}>
          <div className="cs-pg-header bg-dark-blue py-4">
            <Container className="custom-wt">
              <div className="d-flex align-items-center">
                <div className="mt-0 border-right me-4" style={{ width: "20%" }}>
                  <div
                    className="text-white font-size-14 text-uppercase"
                    to={"#"}
                    onClick={() => history.back()}
                  >
                    {" "}
                    <span>
                      <i className=" fas fa-chevron-left me-1"></i>
                    </span>{" "}
                    back to tutor app
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-grow-1">
                  <h6 className="mb-0 font-size-20 text-white w-60 fw-regular">
                    {ActivityData &&
                    ActivityData.activity_level_has_topic_node &&
                    ActivityData.activity_level_has_topic_node.length > 0
                      ? ActivityData.activity_level_has_topic_node[0]
                          .level_name != ""
                        ? ActivityData.activity_level_has_topic_node[0]
                            .level_name + "/"
                        : null
                      : null}
                    {ActivityData &&
                    ActivityData.activity_level_has_topic_node &&
                    ActivityData.activity_level_has_topic_node.length > 0
                      ? ActivityData.activity_level_has_topic_node[0]
                          .topic_name != ""
                        ? ActivityData.activity_level_has_topic_node[0]
                            .topic_name + "/"
                        : null
                      : null}

                    {ActivityData &&
                    ActivityData.activity_node &&
                    ActivityData.activity_node.length > 0 &&
                    ActivityData.activity_node[0].name
                      ? ActivityData.activity_node[0].name
                      : ActivityData &&
                        ActivityData.activity_node &&
                        ActivityData.activity_node.length > 0 &&
                        ActivityData.activity_node[0].node_name
                      ? ActivityData.activity_node[0].node_name
                      : null}
                  </h6>
                  <p className="mb-0 text-uppercase luminous-wht">
                    {" "}
                    <span className="text-yellow me-1">
                      {ActivityData && ActivityData.subject_name
                        ? ActivityData.subject_name
                        : null}
                    </span>{" "}
                    Work Sheet{" "}
                  </p>
                  <div className="luminous-wht font-size-16">
                    <img width={24} className="" src={awicon} alt="" />{" "}
                    {ActivityData && ActivityData.coins_earned
                      ? ActivityData.coins_earned
                      : 0}
                    /
                    {ActivityData &&
                    ActivityData.activity_node &&
                    ActivityData.activity_node.length > 0 && 
                    ActivityData.activity_node[0].coins
                      ? ActivityData.activity_node[0].coins
                      : ActivityData &&
                    ActivityData.LessonActivitiesQuestions &&
                    ActivityData.LessonActivitiesQuestions.length > 0
                      ? ActivityData.LessonActivitiesQuestions[0].question
                          .length * 2
                      : 0}{" "}
                    coins
                  </div>
                </div>
              </div>
            </Container>
          </div>
          <div>
            {ActivityData &&
              ActivityData.LessonActivitiesQuestions &&
              ActivityData.LessonActivitiesQuestions.length > 0
                ? ActivityData.LessonActivitiesQuestions.map(
                    (questionActivity, activeindex) => {
                      if (
                        ActivityData.activity_node &&
                        ActivityData.activity_node.length > 0 
                      ) {
                        return ActivityData.activity_node.map(
                          (InnerActivityData, index) => {
                            if (index === 0) {
                              return (
                              
                                <div className="tool-bar-worksheet" style={{ display: IsTrial != '1' ? 'block' : 'none' }}>
                                  <div className="worksheet-width-hold d-flex align-items-center justify-content-end">
                                    {/* { (
                                      <> */}
                                    
                                    <div className="cs-tools d-flex align-items-center">
                                      
                                        <button onClick={downloadPdf}>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            class="bi bi-printer-fill fx-printer"
                                            viewBox="0 0 16 16"
                                          >
                                            <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1" />
                                            <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                                          </svg>
                                        </button>
                                      
                                    </div>
                                  </div>
                                </div>
                              )
                            }
                          }
                        )
                      }
                    }
                  ) 
                : 
                (null)
            }
          </div>
        </div>
        {ActivityData &&
        ActivityData.LessonActivitiesQuestions &&
        ActivityData.LessonActivitiesQuestions.length > 0
          ? ActivityData.LessonActivitiesQuestions.map(
              (questionActivity, activeindex) => {
                if (
                  ActivityData.activity_node &&
                  ActivityData.activity_node.length > 0 
                ) {
                  return ActivityData.activity_node.map(
                    (InnerActivityData, index) => {
                      if (index === 0) {
                        return (
                          <div className="" style={{ marginTop: "225px" }}>
                            

                            <div className="assessement-section worksheet-width-hold mt-4">
                              <p className="font-size-16 fw-semibold mb-2 mt-2">
                                {ActivityData?.marked_for_homework >= 0 && (
                                  <>
                                    {ActivityData?.homework_tutor_message && ActivityData.marked_for_homework == 1 ? (
                                      <>
                                        <b>Tutor message:</b> {ActivityData.homework_tutor_message}
                                      </>
                                    ) : ActivityData?.lesson_tutor_message ? (
                                      <>
                                        <b>Tutor message:</b> {ActivityData.lesson_tutor_message}
                                      </>
                                    ) : null}
                                  </>
                                )}
                              </p>
                              <p className="font-size-16 fw-semibold mb-2">
                                {ActivityData?.tutor_comments && (
                                  <>
                                    <b>Tutor comments:</b>{" "}
                                    {ActivityData.tutor_comments}
                                  </>
                                )}
                              </p>
                              <div className="hw-list mt-4 pb-100">
                                <ul className="list-unstyled mb-0">
                                  <li className="justify-content-between border-thick">
                                    <div className="d-flex align-items-start gap-4 justify-content-end">
                                      <div className="mb-0 d-flex align-items-center gap-2">
                                        <p className="mb-0">
                                          #
                                          {InnerActivityData.pk_tutor_library_item_id
                                            ? InnerActivityData.pk_tutor_library_item_id
                                            : InnerActivityData.id
                                            ? InnerActivityData.id
                                            : null}
                                        </p>
                                        {/* <span>
                                          <i className="mdi mdi-flag-variant-outline font-size-18"></i>
                                        </span> */}
                                      </div>
                                    </div>

                                    <div>
                                      <div></div>
                                    </div>
                                    <div>
                                      <div id="Canvas_list"></div>
                                    </div>
                                    {/* </div> */}
                                  </li>
                                  {/* <div>
                    <span>Duration: {formatDuration(duration)}</span>
          <br />
          <span>Elapsed: {formatDuration(duration * played)}</span>
          <br />
          <span>Remaining: {remainingTime}</span>
                    </div> */}
                                </ul>
                              </div>

                              {/* { questionActivity.StudentAnsAttempts.length > 0 ? <div className="navigator-wrapper position-relative mt-5">
                  <div className="nv-dg-smile">
                    <img width={400} src={dsmile} alt="" />
                  </div>
                  <div className="navigator-nxt">
                    {InnerActivityData.duration && InnerActivityData.duration!=''? 
                    <p className="opacity-75">
                      SUGGESTED TIME: {InnerActivityData.duration? InnerActivityData.duration : null}
                    </p>
                  : null}
                    <p className="font-size-16 d-flex align-items-center gap-2">
                      <img width={24} src={awicon} /> {ActivityData && ActivityData.coins_earned ? ActivityData.coins_earned : 0}/{ActivityData && ActivityData.LessonActivitiesQuestions && ActivityData.LessonActivitiesQuestions.length > 0 ? ActivityData.LessonActivitiesQuestions.length * 2 : 0} coins
                    </p>

                    {parseInt(IsHomework) === 1 ? 
                     
                      <Button className="btn btn-danger cs-btn-danger mt-1" onClick={() => history.back()}>
                       BACK TO HOMEWORK
                      </Button>
                      :
                      <Button className="btn btn-danger cs-btn-danger mt-1" onClick={() => history.back()}>
                       BACK TO LESSON PLAN
                    </Button>
                      
                    }
                      
                    
                    
                    
                  </div>
                </div>
                : null } */}
                            </div>
                          </div>
                        )
                      }
                    }
                  )
                }
              }
            )
          : null}
      </div>
    </React.Fragment>
  )
}

PreviewWorkSheet.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(PreviewWorkSheet)
